import dt from 'dayjs'
import * as lib from '../lib'
import {
	type IFetchItems,
	type IFetchOfferSpendByOfferScope,
	type TFetchOfferSpendByOfferScopeAggregated,
	type TOfferSpendByOfferScope,
	type TOfferSpendByOfferScopeAggregated,
} from '../types'

export const listOfferSpendByOfferScope = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<TOfferSpendByOfferScope>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take
	}
	const uri: string = 'offer/spend/by/offer/scope'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchOfferSpendByOfferScope>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchOfferSpendByOfferScope): TOfferSpendByOfferScope => {
			const { ...row } = item
			const result = {
				...row,
				agg: row.agg.map((agg: TFetchOfferSpendByOfferScopeAggregated): TOfferSpendByOfferScopeAggregated => {
					return {
						...agg,
						at: dt.utc(agg.at).toDate(),
						createdAt: dt.utc(agg.createdAt).toDate(),
						updatedAt: dt.utc(agg.updatedAt).toDate(),
					}
				}),
				scope: !row.scope ? null : {
					...row.scope,
					createdAt: dt.utc(row.scope.createdAt).toDate(),
					updatedAt: dt.utc(row.scope.updatedAt).toDate(),
				}
			}
			return result
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0,
	}
}
